import {
  getNumberRequiredFn,
  getRequiredFn,
  getValidateNonNegativeNumberFn,
  getValidatePositiveNumberFn,
} from '../../../../../utils/reduxForm/validations';
import { getRequiredFn as zeroNotRequired } from '../utils/validations';
import bigJs from 'big.js';

export const isRequiredFn = zeroNotRequired();
export const isPositiveNumberFn = getValidatePositiveNumberFn();
export const isNonNegativeNumberFn = getValidateNonNegativeNumberFn();
export const reduxRequired = getRequiredFn();
export const numberRequired = getNumberRequiredFn();

export const numberFieldRestrict12Fn = restrictFactory(12);
export const numberFieldRestrict13Fn = restrictFactory(13);
export const numberFieldRestrict12_2Fn = restrictFactory(12, 2);
export const numberFieldRestrict7Fn = restrictFactory(7);
export const numberFieldRestrict14_4Fn = restrictFactory(14, 4);
export const numberFieldRestrict14_2Fn = restrictFactory(14, 2);
export const numberFieldRestrict14_2NoMore400kFn = restrictFactory(null, null, '400000.00');
export const numberFieldRestrict13_2Fn = restrictFactory(13, 2);
export const numberFieldRestrict10_2Fn = restrictFactory(10, 2);
export const numberFieldRestrict4_2Fn = restrictFactory(4, 2);
export const numberFieldRestrict8_2Fn = restrictFactory(8, 2);
export const numberFieldRestrict19_6Fn = restrictFactory(19, 6);
export const numberFieldRestrict17_2Fn = restrictFactory(17, 2);
export const numberFieldRestrict15_2Fn = restrictFactory(15, 2);
export const numberFieldRestrict3_15Fn = restrictFactory(3, 15);
export const numberFieldRestrict24_5Fn = restrictFactory(24, 5);
export const numberFieldRestrict21_2Fn = restrictFactory(21, 2);
export const numberFieldRestrict14_3Fn = restrictFactory(14, 3);
export const numberFieldRestrict15_4Fn = restrictFactory(15, 4);

export function restrictFactory(integerLength, remainderLength, customRestrict) {
  return function ({ value }) {
    if (!value) {
      return true;
    }
    if (customRestrict) {
      return bigJs(value).lte(customRestrict);
    }
    const integerStr = '9'.repeat(integerLength);
    const remainderStr = remainderLength > 0 ? `.${'9'.repeat(integerLength)}` : '';
    return bigJs(value).lte(`${integerStr}${remainderStr}`);
  };
}
